<template>
	<div>
		<navbar/>
		<div class="container-wrap d-flex">
			<component :is="$route.name == 'form' ? 'payment-form' : 'switcher'"/>
		</div>
	</div>
</template>

<script>
	import Switcher from '@/components/Switcher'
	import Navbar from '@/components/Nav'
	import PaymentForm from '@/components/PaymentForm'

	export default {
		name: 'Home',
		components: { Switcher, PaymentForm, Navbar}
	};
</script>